import { Icon } from '@/components/Icon';
import { Reveal } from '@/components/Reveal';
import { Section } from '@/components/Section';
import { services } from '@/content/site';
import styles from './Services.module.css';

export function Services() {
  return (
    <Section
      id="services"
      eyebrow="services"
      title="Three ways we get involved"
      lead="Most engagements start with one of these and grow into another. You are never handed off to a different team when the phase changes."
    >
      <ul className={styles.grid}>
        {services.map((service, index) => (
          <Reveal as="li" key={service.id} className={styles.card} delay={index * 90}>
            <span className={styles.iconWrap}>
              <Icon name={service.icon} size={22} />
            </span>

            <h3 className={styles.title}>
              {service.title}
              <span className={styles.tagline}>{service.tagline}</span>
            </h3>

            <p className={styles.description}>{service.description}</p>

            <ul className={styles.deliverables}>
              {service.deliverables.map((item) => (
                <li key={item} className={styles.deliverable}>
                  <Icon name="check" size={15} />
                  {item}
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </ul>
    </Section>
  );
}
